<div class="chat-export-list-container" [testId]="'chat-export-list-container'">
  <!-- 頂部工具列 -->
  <div class="list-toolbar" [testId]="'chat-export-list-toolbar'">
    <div>
      <h2 class="list-title">{{ 'servicenumber.chat-export.records-title' | i18n }}</h2>
      <span class="muted small">{{ 'servicenumber.chat-export.records-subtitle' | i18n }}</span>
    </div>
    <button
      nz-button
      nzType="default"
      class="refresh-btn"
      [nzLoading]="loading"
      (click)="onRefresh()"
      [testId]="'chat-export-refresh-button'"
    >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      {{ 'servicenumber.chat-export.refresh-btn' | i18n }}
    </button>
  </div>

  <!-- 記錄表格容器（nz-table 統一設計） -->
  <div class="table-scroll-wrapper" [testId]="'chat-export-table-wrapper'">
    <nz-table
      #recordsTable
      [nzData]="records"
      [nzLoading]="loading"
      [nzShowPagination]="records.length > 10"
      [nzPageSize]="10"
      [nzNoResult]="emptyTpl"
      nzSize="middle"
      class="export-nz-table"
      [testId]="'chat-export-records-table'"
    >
      <thead>
        <tr>
          <th nzWidth="110px">{{ 'servicenumber.chat-export.th-month' | i18n }}</th>
          <th nzWidth="260px">{{ 'servicenumber.chat-export.th-file' | i18n }}</th>
          <th nzWidth="150px">{{ 'servicenumber.chat-export.th-stats' | i18n }}</th>
          <th nzWidth="110px">{{ 'servicenumber.chat-export.th-status' | i18n }}</th>
          <th nzWidth="140px">{{ 'servicenumber.chat-export.th-task-owner' | i18n }}</th>
          <th nzWidth="180px">{{ 'servicenumber.chat-export.th-completed-expires' | i18n }}</th>
          <th nzWidth="160px" nzRight>{{ 'servicenumber.chat-export.th-actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of recordsTable.data" [attr.data-testid]="'chat-export-row-' + task.id">
          <!-- 資料月份 -->
          <td>
            <span class="month-badge font-semibold" [testId]="'chat-export-month-' + task.id">{{ task.month }}</span>
          </td>

          <!-- 匯出檔案 -->
          <td>
            <ng-container *ngIf="task.status === ChatExportStatus.READY; else notReadyFileTpl">
              <div class="file-cell" [title]="task.fileName || task.month + '.xlsx'">
                <div class="file-name-row">
                  <i nz-icon nzType="file-excel" nzTheme="outline" class="file-icon text-success"></i>
                  <span class="file-name text-truncate">{{ task.fileName || task.month + ' 對話匯出.xlsx' }}</span>
                </div>
                <div class="file-meta muted small">
                  <span>{{ formatFileSize(task.fileSize) }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #notReadyFileTpl>
              <div *ngIf="task.status === ChatExportStatus.PROCESSING" class="file-processing muted small">
                <i nz-icon nzType="loading" class="mr-4"></i>
                <span>{{ 'servicenumber.chat-export.generating-file' | i18n }}</span>
              </div>
              <div *ngIf="task.status === ChatExportStatus.FAILED" class="file-failed text-danger small">
                <i nz-icon nzType="close-circle" class="mr-4"></i>
                <span>{{ 'servicenumber.chat-export.generate-failed' | i18n }}</span>
              </div>
              <div *ngIf="task.status === ChatExportStatus.EXPIRED" class="file-expired muted small">
                <i nz-icon nzType="clock-circle" class="mr-4"></i>
                <span>{{ 'servicenumber.chat-export.file-cleaned' | i18n }}</span>
              </div>
            </ng-template>
          </td>

          <!-- 對話統計 -->
          <td>
            <ng-container *ngIf="task.status === ChatExportStatus.READY && (task.totalMessages || task.totalRooms); else emptyStatsTpl">
              <div class="stats-cell">
                <div class="stats-messages font-medium">{{ task.totalMessages }} {{ 'servicenumber.chat-export.msg-unit' | i18n }}</div>
                <div class="stats-rooms muted small">{{ task.totalRooms }} {{ 'servicenumber.chat-export.room-unit' | i18n }}</div>
              </div>
            </ng-container>
            <ng-template #emptyStatsTpl>
              <span class="muted">—</span>
            </ng-template>
          </td>

          <!-- 狀態列：嚴格只放狀態與輔助說明，不放任何按鈕 -->
          <td>
            <nz-tag [nzColor]="getStatusTagColor(task.status)">
              {{ getStatusTextKey(task.status) | i18n }}
            </nz-tag>
            <div *ngIf="task.isDeleting && !task.cleanupError" class="status-subtext muted small">
              {{ 'servicenumber.chat-export.status-removing' | i18n }}
            </div>
            <div *ngIf="task.cleanupError" class="status-subtext danger small">
              {{ 'servicenumber.chat-export.status-remove-failed' | i18n }}
            </div>
          </td>

          <!-- 申請人／任務編號 -->
          <td>
            <div class="owner-cell">
              <div class="owner-name font-medium" [title]="task.ownerName">{{ formatOwnerName(task.ownerName) }}</div>
              <div class="task-short-id muted small mono" [title]="task.id">#{{ getShortTaskId(task.id) }}</div>
            </div>
          </td>

          <!-- 完成／到期 -->
          <td>
            <div class="time-cell">
              <div class="completed-time" [title]="task.completedAt">{{ task.completedAt || '—' }}</div>
              <div class="expires-time muted small" [title]="task.expiresAt" *ngIf="task.expiresAt"> 至 {{ task.expiresAt }} </div>
            </div>
          </td>

          <!-- 操作列：集中放置下載、詳情、刪除 -->
          <td nzRight>
            <div class="action-btn-group">
              <button
                *ngIf="task.status === ChatExportStatus.READY"
                nz-button
                nzType="link"
                class="action-link download-btn"
                [disabled]="task.isDeleting"
                (click)="onDownload(task)"
                [testId]="'chat-export-action-download-' + task.id"
              >
                <i nz-icon nzType="download" nzTheme="outline"></i>
                {{ 'servicenumber.chat-export.download-btn' | i18n }}
              </button>

              <button
                nz-button
                nzType="link"
                class="action-link"
                (click)="onDetail(task)"
                [testId]="'chat-export-action-detail-' + task.id"
              >
                {{ 'servicenumber.chat-export.detail-btn' | i18n }}
              </button>

              <button
                nz-button
                nzType="link"
                nzDanger
                class="action-link danger"
                [disabled]="task.isDeleting && !task.cleanupError"
                (click)="onDelete(task)"
                [testId]="'chat-export-action-delete-' + task.id"
              >
                {{ getDeleteBtnTextKey(task) | i18n }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <ng-template #emptyTpl>
        <div class="empty-cell muted">
          {{ 'servicenumber.chat-export.no-records' | i18n }}
        </div>
      </ng-template>
    </nz-table>
  </div>

  <p class="bottom-note muted small">
    {{ 'servicenumber.chat-export.records-bottom-note' | i18n }}
  </p>
</div>
